export const mainMenuDropdown = () => {
    // Eerst de DOM elementen controleren voordat we variabelen declareren
    const menu = document.querySelector('.main-menu');
    if (!menu) {
        return {
            init: () => {
            },
        };
    }

    // Submenu pas ophalen na eerste controle
    const submenu = document.querySelector('.main-submenu');
    if (!submenu) {
        return {
            init: () => {
            },
        };
    }

    // Nu pas de hover elementen ophalen
    const hoverSubMenuItems = document.querySelectorAll('.main-submenu .hover-submenu');

    // Submenu hoogte berekenen wanneer nodig, niet vooraf
    const getSubmenuHeight = () => submenu.clientHeight;

    const setNavTopOffset = () => {
        // Set the offset of the nav-dropdown according to the height of the main-menu section
        const computedStyle = getComputedStyle(menu);
        if (computedStyle.getPropertyValue('--main-nav-top').trim() === '0') {
            // If the css-variable is not already filled in set the variable to the height of the main-menu section
            menu.style.setProperty('--main-nav-top', menu.clientHeight + 'px');
        }
    };

    const setHeightOfDropdownMenu = (objMenuItem) => {
        // Set the height of the dropdown-menu according to the highest section of the dropdown-menu (submenu (left part) || sub-submenu (right part))
        if (!objMenuItem) {
            return;
        }

        // Get the current sub-submenu of the given menu-item
        const currentMainSubSubMenu = objMenuItem.querySelector('.main-sub-submenu');
        if (!currentMainSubSubMenu) {
            return; // Voorkom fouten als .main-sub-submenu ontbreekt
        }

        const submenuHeight = getSubmenuHeight(); // Dynamisch berekenen
        const elementHeight = currentMainSubSubMenu.clientHeight;

        // Set the height according to the highest value of the two elements
        const maxHeight = (submenuHeight > elementHeight) ? submenuHeight : elementHeight;
        submenu.style.height = maxHeight + 'px';
    };

    const resetSubmenuHeight = () => {
        // Reset de hoogte wanneer de muis het menu verlaat
        submenu.style.height = '';
    };

    const init = () => {
        // Set the submenu
        setNavTopOffset();

        if (hoverSubMenuItems?.length > 0) {
            hoverSubMenuItems.forEach(subitem => {
                // When the nav subitems are hovered, dynamically set the height according to the highest section in the menu (submenu || sub-submenu)
                subitem.addEventListener('mouseenter', (event) => {
                    const objSubitem = event.currentTarget;
                    // Gebruik window.requestAnimationFrame in plaats van setTimeout voor betere prestaties
                    window.requestAnimationFrame(() => {
                        setHeightOfDropdownMenu(objSubitem);
                    });
                });

                // Voeg mouseleave event toe om te resetten als subitem verlaten wordt
                subitem.addEventListener('mouseleave', resetSubmenuHeight);
            });

            // Voeg ook een event toe aan het hoofdmenu om terug te resetten
            const mainSubmenuWrapper = submenu.closest('.main-submenu-wrapper');
            if (mainSubmenuWrapper) {
                mainSubmenuWrapper.addEventListener('mouseleave', resetSubmenuHeight);
            }
        }

        // Voeg resize event handler toe om navigatie opnieuw te berekenen bij venster grootte wijzigingen
        window.addEventListener('resize', () => {
            setNavTopOffset();
            // Reset alle menu hoogtes
            resetSubmenuHeight();
        });
    };

    return {
        init,
    };
};